export default __webpack_public_path__ + "static/media/IMN_4863.37984a67.jpg";